import React from 'react';
import PropTypes from 'prop-types';
import styledComponent from '../../../utils/styledComponent';
import theme from '../../../theme';

// Inline form-validation message, shown below a field (or group of
// fields) when the user's input is invalid. Renders `null` when
// `message` is empty so callers can pass the result of a validator
// function unconditionally without gating the render themselves.
//
// Uses `role="alert"` so screen readers announce the message as it
// appears. Pair with `aria-describedby` on the related input by
// passing the same `id` to both.

const StyledSpan = styledComponent('span', {
  display: 'block',
  marginTop: theme.spacing.labelGap,
  fontSize: theme.typography.label.fontSize,
  color: theme.colors.danger,
});

function FieldError({ id, message, 'data-testid': dataTestId }) {
  if (!message) return null;
  return (
    <StyledSpan id={id} role="alert" data-testid={dataTestId}>
      {message}
    </StyledSpan>
  );
}

FieldError.propTypes = {
  id: PropTypes.string,
  message: PropTypes.string,
  'data-testid': PropTypes.string,
};

FieldError.defaultProps = {
  id: undefined,
  message: '',
  'data-testid': 'field-error',
};

export default FieldError;
